import styled from "styled-components";
const SoulStyleContainer = styled.div`
    // margin-bottom: 50px;

    // @media (max-width: 575px) {
    //     margin-bottom: 50px;
    // }

    // @media (max-width: 1199px) {
    //     margin-bottom: 70px;
    // }
`;
export default SoulStyleContainer;
